module.exports = __webpack_public_path__ + "images/category_lp/trading_card/main-bg_2523317bc0ff864e4f24c77b613222d3.jpg";